import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import { useCommonStyles } from "@pages/ManualDocumentV2/hooks/useCommonStyles";
import { LineItemsTableRow } from "./LineItemsTableRow";

interface ILineItemsTableProps {
  translate: (text: any, options?: any) => string;
  lineItems: any[];
  itemRemove: (index: number) => void;
  handleUpdateLineItem: (index: number, updatedItem: any) => void;
}

export const LineItemsTable = ({
  translate,
  lineItems,
  itemRemove,
  handleUpdateLineItem,
}: ILineItemsTableProps) => {
  const { tableHeader, tableContainer, table } = useCommonStyles();
  const { palette } = useTheme();
  const headers = [
    { label: translate("description"), align: "left" as const },
    { label: translate("reference_code"), align: "right" as const },
    { label: translate("quantity"), align: "right" as const },
    { label: translate("unit_price"), align: "right" as const },
    { label: translate("tax"), align: "right" as const },
    { label: translate("total"), align: "right" as const },
    { label: "", align: "right" as const },
  ];

  return (
    <TableContainer
      sx={{
        ...tableContainer,
        overflowX: "auto",
        maxHeight: 500, // adjust height as needed
        overflowY: "auto",
      }}
    >
      <Table
        size="small"
        sx={{
          ...table,
          minWidth: 900, // adjust based on your columns
        }}
      >
        <TableHead sx={tableHeader}>
          <TableRow>
            {headers.map((h, i) => (
              <TableCell key={i} align={h.align} sx={{ fontWeight: 600 }}>
                {h.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {lineItems.length > 0 ? (
            lineItems.map((item, index) => (
              <LineItemsTableRow
                key={item.id}
                row={item}
                index={index}
                itemRemove={() => itemRemove(index)}
                itemUpdate={() => handleUpdateLineItem(index, item)}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={headers.length} align="center">
                {translate(
                  "no_items_added-click_on_add__line_item_to_add_items",
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
